"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TonicVestingFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "contract IERC20",
                name: "_token",
                type: "address",
            },
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beneficiary",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "TokenReleased",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beneficiary",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "TokenRevoked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beneficiary",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "TokenVested",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_receiver",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_startTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_periods",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_cliff",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_duration",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "addVesting",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "beneficiaries",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_receiver",
                type: "address",
            },
        ],
        name: "revoke",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_receiver",
                type: "address",
            },
        ],
        name: "vestingAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "vestingInfo",
        outputs: [
            {
                internalType: "address",
                name: "beneficiary",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "startTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "cliff",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "duration",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "periods",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "allocated",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "released",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "revoked",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
class TonicVestingFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(_token, _owner, overrides) {
        return super.deploy(_token, _owner, overrides || {});
    }
    getDeployTransaction(_token, _owner, overrides) {
        return super.getDeployTransaction(_token, _owner, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.TonicVestingFactory = TonicVestingFactory;
TonicVestingFactory.bytecode = _bytecode;
TonicVestingFactory.abi = _abi;
//# sourceMappingURL=TonicVestingFactory.js.map